import { WEEK_DAY } from "../values/dropdownItems";

function workTimeWithCompeleteTitle(workTimes: any) {
  const workTimesWithCompleteTitle = workTimes?.map((item: any) => {
    return {
      ...item,
      completeName:
        WEEK_DAY.find((dopDownItem) => dopDownItem.value === item?.dayName)
          ?.name +
        " : " +
        item?.startTime +
        " تا " +
        item?.endTime,
    };
  });
  return workTimesWithCompleteTitle;
}

export default workTimeWithCompeleteTitle;
